export default __webpack_public_path__ + "static/media/illustrator.15a09383.png";